import { render, staticRenderFns } from "./ReorderControls.vue?vue&type=template&id=5848e010&scoped=true&"
import script from "./ReorderControls.vue?vue&type=script&lang=js&"
export * from "./ReorderControls.vue?vue&type=script&lang=js&"
import style0 from "./ReorderControls.vue?vue&type=style&index=0&id=5848e010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848e010",
  null
  
)

export default component.exports